import {NgModule} from '@angular/core';
import {DragDropFileUploadModule} from '@mydocma/component-library/src/lib/drag-drop-file-upload';
import {MatFormFieldModule} from '@angular/material/form-field';
import {TranslateModule} from '@ngx-translate/core';
import {MatSelectModule} from '@angular/material/select';
import {CommonModule} from '@angular/common';
import {MatInputModule} from '@angular/material/input';
import {MydocmaFormModule} from '@mydocma/component-library/src/lib/form';
import {MatStepperModule} from '@angular/material/stepper';
import {ExportStepDataMappingComponent} from './components/step-data-mapping/export-step-data-mapping.component';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AgGridModule} from 'ag-grid-angular';
import {MatIconModule} from '@angular/material';
import {FlexLayoutModule} from '@angular/flex-layout';
import {CustomMatIconModule} from '@mydocma/component-library/src/lib/custom-mat-icon';
import {ExportStepDataResultComponent} from './components/step-data-result/export-step-data-result.component';
import {MatDialogModule} from '@angular/material/dialog';
import {PromptDialogModule} from '@mydocma/component-library/src/lib/prompt-dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MydocmaStepperModule} from '../stepper/stepper.module';
import {ExportStepperComponent} from './components/export-stepper/export-stepper.component';

@NgModule({
    declarations: [
        ExportStepDataMappingComponent,
        ExportStepDataResultComponent,
        ExportStepperComponent
    ],
    imports: [
        CommonModule,
        CustomMatIconModule,
        DragDropFileUploadModule,
        FlexLayoutModule,
        FormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatDividerModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatStepperModule,
        MatTableModule,
        MydocmaFormModule,
        MydocmaStepperModule,
        PromptDialogModule,
        ReactiveFormsModule,
        TranslateModule,
        AgGridModule.withComponents([])
    ],
    exports: [
        MatStepperModule,
        ExportStepDataMappingComponent,
        ExportStepDataResultComponent,
        ExportStepperComponent
    ]
})
export class MydocmaExportModule {
}
